export interface Ansible {
  id: string
  terminalId: string
  name: string
  maxMacMinis: number
  maxPhysicalPhones: number
  currentMacMinis: number
  currentPhysicalPhones: number
  availableMacMinis: number
  availablePhysicalPhones: number
  status: AnsibleStatus
  createdAt: string
  updatedAt: string
  terminal?: import('./terminal').Terminal
}

export enum AnsibleStatus {
  RECEIVED = 'RECEIVED',
  ASSEMBLY = 'ASSEMBLY',
  READY = 'READY',
  ACTIVE = 'ACTIVE',
  MAINTENANCE = 'MAINTENANCE',
  RELOCATING = 'RELOCATING',
  DECOMMISSIONED = 'DECOMMISSIONED',
}

export interface PaginatedAnsibleResponse {
  data: Ansible[]
  pagination: {
    total: number
    count: number
    limit: number
    offset: number
    hasMore: boolean
    currentPage: number
    totalPages: number
  }
}

export interface AnsibleCountResponse {
  total: number
  byStatus: {
    [key in AnsibleStatus]: number
  }
}
